import React from 'react';
import { Link } from 'react-router-dom';

import { sortTemplatesByLabel, updateSurveyTemplate} from '../common/Utilities';
import SurveyTemplateService from '../services/SurveyTemplateService'
import SurveyList from "./SurveyList";
import SurveyService from '../services/SurveyService'
import Survey from '../models/SurveyModel';
import { getSurveyTemplates, loadSurveyFromAssetView } from '../services/CorrelatorService';
import { sortByJob, getSelectedTemplates, getDataFromState } from '../common/Utilities';

import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { ChoiceGroup } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import { Label } from 'office-ui-fabric-react';

import { copyArray } from '../common/Utilities'

import { marshall, unmarshall } from '@aws-sdk/util-dynamodb';



import '../App.css';

class SelectSurveyTemplate extends React.Component {

    constructor(props) {
        super(props);

        const localState = {

            hasChanges: false,

            // The list of surveys to choose from
            existingSurveys: [],

            // Used to identify if the user has confirmed their selection for
            // using the existing job as the templates for this survey
            selectionConfirmed: false,

            // Loading an existing survey for edit
            openDialogHidden: true,
            askOpenSurvey: true,

            showCopyData: false,
            copyDataSelected: false,

            isBusy:false,

            configurationMethod: "new",
        };

        let sharedState = { ...props.data };
        sharedState.selectedTemplates = getSelectedTemplates(props.data.survey);
        this.state = { ...sharedState, ...localState };
    }

    resetSelectedTemplates() {
        // If this survey has templates put them into the selected templates list,
        // This will ensure that it will show up in the checkbox list
        // object looks like: 
        // Templates.L[ M: { Columns {L:[]}, Value: {S: ""}, Label: {S: ""} } ]
        const t = this.state.survey.Templates;
        let selectedTemplates = [];
        if (t && t.L && t.L.length > 0) {
            t.L.forEach(item => {
                console.log(item);
                selectedTemplates.push(item.M.Value.S);
            });
        }
        this.setState({selectedTemplates:selectedTemplates});
    }

    async componentDidMount() {

        if (this.state.templates.length === 0) {
            const db = new SurveyTemplateService();
            if (!(this.state.templates && this.state.templates.length>0)) {
                const templates = await db.scan();
                this.setState(this.setState({ templates: templates.sort(sortTemplatesByLabel) }));
                this.props.updateCommonState(getDataFromState(this.state));
            }
        }
    }

    templateLabel = (value) => {
        const item = this.state.templates.find((item) => item.value === value);
        return item ? item.label : `Error - Template ${value} not found`;
    };

    templateAvType = (value) => {
        const item = this.state.templates.find((item) => item.value === value);
        return item ? item.avType : `Error - Template ${value} not found`;
    };

    setStateForProperty(propertyName, value, callback) {
        let survey = { ...this.state.survey }
        survey[propertyName] = value;
        this.setState({ survey: survey, hasChanges: true }, callback);
        this.props.onSurveyChange(true);
    };

    saveRecordOnly = () => {
        this.saveChanges(0);
    };
    saveAndNext = () => {
        this.saveChanges(1);
    };
    saveAndPrevious = () => {
        this.saveChanges(-1);
    };

    saveChanges = (moveTo) => {
        if (this.state.configurationMethod === "existing" && this.state.selectedSurvey.job !== "" && !this.state.selectionConfirmed) {
            // set the saveMoveToState so the onOpenDialog() knows which parameter to pass to saveChanges()
            // when it's finished loading the selected survey.
            this.setState({ saveMoveTo: moveTo }, () => {
                this.setState({ openDialogHidden: false })
            });
        } else if (this.state.hasChanges) {
            
            // Add any templates to the survey that don't exist
            let modifiedTemplates = false;
            const survey = this.state.survey;
            if (this.state.configurationMethod === "existing")
            {
                modifiedTemplates = true;
            } else {
                this.state.selectedTemplates.forEach(item => {
                    survey.addTemplateIfMissing(item,  this.templateAvType(item), this.templateLabel(item));
                    // Don't add any attributes
                    // this is so that we know that the template is new, it won't
                    // have any columns
                    //survey.setColumnsFromTemplate(requiredFieldNames(this.state.templates, item), this.state.templates.filter(t => t.value === item)[0]);

                    modifiedTemplates = true;
                });
                // Remove any Surveyes that are not in the selectedTemplates collection
                const templateCount = survey.templateCount();
                this.state.survey.removeTemplatesNotInList(this.state.selectedTemplates);
                if (templateCount !== survey.templateCount()) {
                    modifiedTemplates = true;
                }
            }
            // if modifiedTemplates then a new template was added or removed
            if (modifiedTemplates) {

                // Set the timestamp before saving. It's a new record - 
                // this tells when it was updated and not to validate if a user does a back and changes something
                const thisInstance = this;
                const timeStamp = (new Date()).toISOString();
                
                this.setStateForProperty("Templates", survey.Templates, () => {
                    this.setStateForProperty("schemaDTS", timeStamp, async   () => {
                        // Save the survey
                        const db = new SurveyService();
                        db.put(new Survey().fromSimple(thisInstance.state.survey).getDbObject());
                        //db.put(new Survey().fromSimple(thisInstance.state.survey).getSimpleObject());
                        //console.log(JSON.stringify(values, 0, 2))
                        if (this.state.copyDataSelected == true) {
                            this.setState({isBusy: true });
                            console.log("prevSurvey: " + this.state.selectedSurvey.job + "  newSurvey: " + this.state.survey.jobNumVendor)
                            const result = await loadSurveyFromAssetView(this.state.selectedSurvey.job, this.state.survey.jobNumVendor);
                            this.setState({ isBusy: false });
                            console.log(result);
                            alert(result.message);
                            thisInstance.props.onSave(getDataFromState(thisInstance.state), moveTo);
                        }
                        else {                          
                            thisInstance.props.onSave(getDataFromState(thisInstance.state), moveTo);
                        }
                    });
                });
            } else {
                if (moveTo !== 0) { this.props.moveTo(moveTo); }
            }
        } else if (this.state.survey.Templates.L.length > 0) {
            if (moveTo !== 0) {this.props.moveTo(moveTo); }
        }
        this.setState({ hasChanges: false });
        this.props.onSurveyChange(false);
    }

    handleOnNextButtonClicked = () => {
        // If selecting from existing survey and the selection hasn't been confirmed
        // the confirmation dialog is opened, which if confirmed will load the templates
        if (this.state.configurationMethod === "existing" && !this.state.selectionConfirmed) {
            this.setState({openDialogHidden: false});
        } else {
            this.props.nextStep({ ...this.state });
        }
    };

    handleOnPreviousButtonClicked = () => {
        // If selecting from existing survey and the selection has been confirmed
        // the loaded templates are removed and the list projects dialog will re-appear
        if (this.state.configurationMethod === "existing" && this.state.selectionConfirmed) {
            const thisSurvey = this.state.survey;
            thisSurvey.Templates = [];
            this.setState({selectionConfirmed: false, survey: thisSurvey, selectedSurvey: {job: "", client: ""}},
                this.resetSelectedTemplates // reset our selected list after the state has been updated for the survey.Templates
            );
        } else {
            this.props.previousStep({ ...this.state });
        }
    };

    onSurveyTemplateTypeChange = (e, option) => {
        if (option.key && this.state.existingSurveys.length===0){
            const db = new SurveyService();
            const thisSurvey = this.state.survey;
            db.list().then(surveys => {
                this.setState({ existingSurveys: surveys.filter((t) => 
                    // skip the newly added survey (it stores to the database from the previous screen)
                    t.jobNumVendor !== thisSurvey.jobNumVendor || t.client !== thisSurvey.client
                ).sort(sortByJob) });
            });
        }
        this.setState({ configurationMethod: option.key });
    };

    selectSurveySave = (job, client) =>
    {
        this.selectSurvey(job,client,this.saveAndNext);
    };
    selectSurvey = (job, client, callback) => {
        if (this.state.selectedSurvey.job === job && this.state.selectedSurvey.client === client) {
            this.setState({ selectedSurvey: { job: "", client: "" } });          
        } else {
            this.setState({ selectedSurvey: { job: job, client: client}}, callback);
        }

        if (this.state.survey.client === client) {
            this.setState({ showCopyData: true });
        }
        else {
            this.setState({ showCopyData: false });
        }       
    };

    onCopyDataChange = (e) => {
        console.log(e.currentTarget.checked)
        this.setState({ copyDataSelected: e.currentTarget.checked });      
    }

    onCheckboxChange = (checked, value) => {
        const updatedSelectedItem = this.state.selectedTemplates ? copyArray(this.state.selectedTemplates) : [];
        if (checked) {
            // add the option if it's checked
            updatedSelectedItem.push(value);
        } else {
            // remove the option if it's unchecked
            const currIndex = updatedSelectedItem.indexOf(value);
            if (currIndex > -1) {
                updatedSelectedItem.splice(currIndex, 1);
            }
        }
        this.setState({ selectedTemplates: updatedSelectedItem, hasChanges: true });
        this.props.onSurveyChange(true);
    };

    checkboxStyles = () => {
        return {
          root: {
            marginTop: '6px',
            width: '300px'
          }
        };
    };

    openSurveyDialog = () => { this.setState({openDialogHidden: false }) };

    cancelOpenDialog = () => {
        this.setState({
            askOpenSurvey: false,
            openDialogHidden: true
        });
    }

    onOpenDialog = async () => {
        // Get the survey for the selected item
        const db = new SurveyService();
        const existingSurvey = await db.get(this.state.selectedSurvey.job, this.state.selectedSurvey.client);

        const masterTemplates = await getSurveyTemplates();
      
        var cnt = existingSurvey.getSimpleObject().Templates.L.length;
        //var newTemplates = [];
        for (let i = cnt - 1; i > -1; i--) {
            var newTemplate = updateSurveyTemplate(masterTemplates, existingSurvey.getSimpleObject().Templates.L[i]);
        
            if (newTemplate !== null) {
                console.log(existingSurvey.simpleObject.Templates.L[i])
                console.log(newTemplate);
               
                //replace template with updated version               
                existingSurvey.simpleObject.Templates.L[i] = newTemplate;
               
            }
            else {
                // remove invalid tempate
                existingSurvey.simpleObject.Templates.L.splice(i, 1);
            }
        }
        var newSurvey = new Survey().fromDb(marshall(existingSurvey.simpleObject));
        console.log(newSurvey);
        
        // Put the templates int this survey's Templates
       
        let thisSurvey = this.state.survey;
       
        // The set is required to make sure both the dbObject and simpleObject refer to the correct data
        console.log(thisSurvey.Templates);
            thisSurvey.Templates = thisSurvey.setTemplates(JSON.parse(JSON.stringify(existingSurvey.getSimpleObject().Templates))).Templates;
        console.log(thisSurvey.Templates);

        // put the Templates into the state and reset messages
        this.setState({ selectionConfirmed: true, survey: { ...thisSurvey }, hasChanges: true },
            () => { 
                // Reset the selected templates to show the templates from the loaded survey
                this.resetSelectedTemplates();
                this.cancelOpenDialog()
                this.props.onSurveyChange(true);
                this.saveChanges(this.state.saveMoveTo);
            });
    };
  
    render() {
       // console.log(this.state);
    return (
      <div className="container-fluid">
        <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12">
                    <h2 className="heading">Survey Templates</h2>
        <div style={{ marginTop: "25px" }}>
        { (this.state.isNewSurvey || this.state.survey.Templates.L.length === 0) &&
          <ChoiceGroup style={{ verticalAlign: "middle" }}
            defaultSelectedKey={this.state.configurationMethod}
            options={[
                {
                    key: 'new',
                    text: 'Manually create a new survey'
                },
                {
                    key: 'existing',
                    text: 'Create a new survey from an existing job'
                }
            ]}
            onChange={this.onSurveyTemplateTypeChange}
            label="Pick the survey creation method"
            required={true}
        />
        }
        </div>
        <div style={{ marginTop: "25px" }}>
        { (this.state.configurationMethod === "new" || 
                            (this.state.configurationMethod === "existing" && this.state.selectionConfirmed)) &&
                            <div>
                            <Label required={true}>Select the template(s) to use for this survey</Label>
                            <div className="lds-spinner" style={{ marginLeft: "50px", display: (this.state.templates.length === 0) ? "block" : "none"}}><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                            {
                                <div style={{ maxHeight: "600px", overflowY: "auto" }}>                                   
                    {this.state.templates && this.state.templates.map(item => (
                        <Checkbox
                        key={item.value}
                        label={item.label}
                        checked={this.state.selectedTemplates.indexOf(item.value) >= 0}
                        onChange={(e,checked) => {this.onCheckboxChange(checked,item.value)}}
                        styles={this.checkboxStyles}
                        />
                    ))}
                </div>
            }
            </div>
        }
        { this.state.configurationMethod === "existing" && !this.state.selectionConfirmed &&
                <div className="row">                           
                            <SurveyList surveys={this.state.existingSurveys} onSelect={this.selectSurvey} onSelectSave={this.selectSurveySave} />
                            <div className="lds-spinner" style={{ display: (this.state.existingSurveys.length === 0) ? "block" : "none", marginLeft: "50px", marginTop: "14px" }}><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
            </div>
        }
        </div>
        {/* <div className="row" style={{ marginTop: "15px" }}>
            <div className="col-xs-2">
                <button onClick={this.handleOnPreviousButtonClicked} className="btn btn-default">&laquo; Previous</button>
            </div>
            <div className="col-xs-2">
                <button onClick={this.handleOnNextButtonClicked} 
                disabled={(this.state.configurationMethod === "new" && (this.state.selectedTemplates.length===0)) ||
                          (this.state.configurationMethod === "existing" && (this.state.selectedSurvey.job === ""))}
                className="btn btn-default">Next &raquo;</button>
            </div>
        </div> */}

            <div className="buttonRow" style={{ marginTop: "15px" }}>
            <div>
                            <button style={{ 'fontSize': '12px', 'color': '#676767' }} type="button" onClick={this.saveAndPrevious} className="btn btn-default">Previous</button>
            </div>
            <div>
                            <button style={{ 'fontSize': '12px', 'color': '#676767' }} type="button" onClick={this.saveAndNext} 
                disabled={
                    (this.state.configurationMethod === "new" && this.state.selectedTemplates.length===0) ||
                    (this.state.configurationMethod === "existing" && this.state.selectedSurvey.job.length===0)
                    } className="btn btn-default">Next</button>
            </div>
            <div >
                            <button style={{ 'fontSize': '12px', 'color': '#676767' }} type="button" onClick={this.saveRecordOnly} className="btn btn-default">Save</button>
            </div>
            <div>
                            <button style={{ 'fontSize': '12px', 'color': '#676767' }} type="button" className="btn btn-default">Undo Changes</button>
            </div>
            <div>
                <Link to="/">
                                <button style={{ 'fontSize': '12px', 'color': '#676767' }} className="btn btn-default">Home</button>
                </Link>
            </div>
        </div> 

        </div>
        <div className="col-sm-1 col-md-2 col-lg-3"></div>
            </div>
            <div className="centered" style={this.state.isBusy ? {} : { display: 'none' }}>
                <div className="lds-spinner" ><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
            </div>
        <Dialog
            hidden={this.state.openDialogHidden}
            onDismiss={this.cancelOpenDialog}
            dialogContentProps={{
                type: DialogType.normal,
                title: 'Confirm Selection',
                subText:
                "Would you like to use the selected surveys templates for the new survey?"
            }}
            modalProps={{
                isBlocking: true
            }}
            >
            <p>Job Number: { this.state.selectedSurvey.job}</p>
                <p>Client: {this.state.selectedSurvey.client}</p>
               
                <div style={this.state.showCopyData ? {} : { display: 'none' }}>
                    <input type="checkbox" name="copySurveyDataCB" style={{ 'marginRight': '10px' }} onChange={(e) => { this.onCopyDataChange(e) }} />
                    <label>Copy survey data from CorrMonitor</label>
                </div>
            <DialogFooter>
                    <PrimaryButton  onClick={this.onOpenDialog} text="Open" />
                    <DefaultButton  onClick={this.cancelOpenDialog} text="Cancel" />
            </DialogFooter>
        </Dialog>
      </div>
    );
  }
}

export default SelectSurveyTemplate;
